/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';

import { Box, Flex, Text, Link } from '..';
import Picture from '../Picture';

export interface FooterAppDownloadProps {
  appStore: {
    link: string;
    imageSrc: string;
  };
  googlePlay: {
    link: string;
    imageSrc: string;
  };
}

const imgStyle = {
  width: ['131px', '181px'],
  height: ['50px', '69px'],
};

export const FooterAppDownload = ({
  appStore,
  googlePlay,
}: FooterAppDownloadProps): React.JSX.Element => (
  <Box sx={{ mt: [4, null, null, 0] }}>
    <Text as="h2" variant="footerFirstSectionHeading">
      Download the free Audio Tour
    </Text>
    <Flex>
      <Link sx={{ mr: 3 }} to={appStore.link}>
        <Box sx={imgStyle}>
          <Picture
            alt="Download the app from the apple app store"
            key="apple"
            src={appStore.imageSrc}
          />
        </Box>
      </Link>
      <Link to={googlePlay.link}>
        <Box sx={imgStyle}>
          <Picture
            alt="Get it on Google Play"
            key="google"
            src={googlePlay.imageSrc}
          />
        </Box>
      </Link>
    </Flex>
  </Box>
);
